// extracted by mini-css-extract-plugin
export default {"title":"O--z","warning":"P--z","sizeOptionsLegendText":"Q--z"};